@if (chipDetails) {
    <div class="flex flex-row justify-between items-center mb-4">
        <h2 class="text-xl font-semibold text-gray-800">{{ "chipDetails.title" | translate }}</h2>
        <div class="flex flex-row gap-2">
            <button
                class="inline-flex items-center justify-center gap-2 rounded-lg transition px-4 py-3 text-sm bg-white text-gray-700 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:opacity-50 mr-4 cursor-pointer"
                type="button"
                [routerLink]="['change-owner']"
                >
                {{ "button.changeOwner" | translate }}
            </button>
             <button
                class="inline-flex items-center justify-center gap-2 rounded-lg transition px-4 py-3 text-sm bg-white text-gray-700 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:opacity-50 mr-4 cursor-pointer"
                type="button"
                [routerLink]="['change-address']"
                >
                {{ "button.changeAddress" | translate }}
            </button>
        </div>
    </div>

    @if (chipDetails.registrationDetails) {
        <div class="rounded-2xl border border-gray-200 bg-white mb-4">
            <div class="px-4 py-5">
                <h3 class="text-base font-medium text-gray-800">{{ "chipDetails.registrationInfo" | translate }}</h3>
            </div>
            <div class="border-t border-gray-200 p-4">
                <ul class="divide-y divide-gray-100">
                    <li class="flex items-center gap-5 py-2.5">
                        <span class="w-1/2 text-sm text-gray-500">{{ "chipDetails.codeLabel" | translate }}</span>
                        <span class="w-1/2 text-sm font-medium text-gray-700">{{ chipDetails.codeInfo.code }}</span>
                    </li>
                    <li class="flex items-center gap-5 py-2.5">
                        <span class="w-1/2 text-sm text-gray-500">{{ "chipDetails.registrationDateLabel" | translate }}</span>
                        <span class="w-1/2 text-sm font-medium text-gray-700">{{ chipDetails.registrationDetails.date | date:'medium' }}</span>
                    </li>
                    <li class="flex items-center gap-5 py-2.5">
                        <span class="w-1/2 text-sm text-gray-500">{{ "chipDetails.emailSentStatusLabel" | translate }}</span>
                        <span class="w-1/2 text-sm font-medium text-gray-700">
                            @if (chipDetails.registrationDetails.isEmailSent) {
                                <svg class="size-6" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path d="m4.5 12.75 6 6 9-13.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            } @else {
                                <svg class="size-6" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6 18 18 6M6 6l12 12" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            }
                        </span>
                    </li>
                    <li class="flex items-center gap-5 py-2.5">
                        <span class="w-1/2 text-sm text-gray-500">{{ "chipDetails.pdfGeneratedStatusLabel" | translate }}</span>
                        <span class="w-1/2 text-sm font-medium text-gray-700">
                            @if (chipDetails.registrationDetails.pdfUrl) {
                                <svg class="size-6" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path d="m4.5 12.75 6 6 9-13.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            } @else {
                                <svg class="size-6" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6 18 18 6M6 6l12 12" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            }
                        </span>
                    </li>
                </ul>
            </div>
        </div>
    }

    @if (chipDetails.owner) {
        <div class="rounded-2xl border border-gray-200 bg-white mb-4">
            <div class="px-4 py-5">
                <h3 class="text-base font-medium text-gray-800">{{ "chipRegistration.owner.sectionTitle" | translate }}</h3>
            </div>
            <div class="border-t border-gray-200 p-4">
                <ul class="divide-y divide-gray-100">
                    <li class="flex items-center gap-5 py-2.5">
                        <span class="w-1/2 text-sm text-gray-500">{{ "chipRegistration.owner.email" | translate }}</span>
                        <span class="w-1/2 text-sm font-medium text-gray-700">{{ chipDetails.owner.email }}</span>
                    </li>
                    <li class="flex items-center gap-5 py-2.5">
                        <span class="w-1/2 text-sm text-gray-500">{{ "chipRegistration.owner.phone" | translate }}</span>
                        <span class="w-1/2 text-sm font-medium text-gray-700">{{ chipDetails.owner.phone }}</span>
                    </li>
                    <li class="flex items-center gap-5 py-2.5">
                        <span class="w-1/2 text-sm text-gray-500">{{ "chipRegistration.owner.fullName" | translate }}</span>
                        <span class="w-1/2 text-sm font-medium text-gray-700">{{ chipDetails.owner.fullName }}</span>
                    </li>
                    <li class="flex items-center gap-5 py-2.5">
                        <span class="w-1/2 text-sm text-gray-500">{{ "chipRegistration.owner.idNumberLabel" | translate }}</span>
                        <span class="w-1/2 text-sm font-medium text-gray-700">{{ chipDetails.owner.idNumber }}</span>
                    </li>
                </ul>
            </div>
        </div>
    }

    <app-address-render-info [address]="chipDetails.owner.addresses" [ownerAddress]="true" />

    <div class="rounded-2xl border border-gray-200 bg-white mb-4">
        <div class="px-4 py-5">
            <h3 class="text-base font-medium text-gray-800">{{ "chipRegistration.animal.sectionTitle" | translate }}</h3>
        </div>
        <div class="border-t border-gray-200 p-4">
            <ul class="divide-y divide-gray-100">
                <li class="flex items-center gap-5 py-2.5">
                    <span class="w-1/2 text-sm text-gray-500">{{ "chipRegistration.animal.type" | translate }}</span>
                    <span class="w-1/2 text-sm font-medium text-gray-700">{{ chipDetails.animal.type }}</span>
                </li>
                @if (chipDetails.animal.type !== "rabbitFerry") {
                    <li class="flex items-center gap-5 py-2.5">
                        <span class="w-1/2 text-sm text-gray-500">{{ "chipRegistration.animal.breed" | translate }}</span>
                        <span class="w-1/2 text-sm font-medium text-gray-700">{{ getAnimalBreed() }}</span>
                    </li>
                }
                <li class="flex items-center gap-5 py-2.5">
                    <span class="w-1/2 text-sm text-gray-500">{{ "chipRegistration.animal.sex" | translate }}</span>
                    <span class="w-1/2 text-sm font-medium text-gray-700">
                        @if (chipDetails.animal.sex === '1') {
                            {{ "chipRegistration.animal.male" | translate }}
                        } @else {
                            {{ "chipRegistration.animal.female" | translate }}
                        }
                    </span>
                </li>
                <li class="flex items-center gap-5 py-2.5">
                    <span class="w-1/2 text-sm text-gray-500">{{ "chipRegistration.animal.dateOfBirth" | translate }}</span>
                    <span class="w-1/2 text-sm font-medium text-gray-700">{{ chipDetails.animal.dateOfBirth | date:'medium' }}</span>
                </li>
                <li class="flex items-center gap-5 py-2.5">
                    <span class="w-1/2 text-sm text-gray-500">{{ "chipRegistration.animal.chipLocation" | translate }}</span>
                    <span class="w-1/2 text-sm font-medium text-gray-700">
                        @if (chipDetails.animal.chipLocation === '1') {
                            {{ "chipRegistration.animal.leftNeck" | translate }}
                        } @else {
                            {{ "chipRegistration.animal.crossNeck" | translate }}
                        }
                    </span>
                </li>
                <li class="flex items-center gap-5 py-2.5">
                    <span class="w-1/2 text-sm text-gray-500">{{ "chipRegistration.animal.coatType" | translate }}</span>
                    <span class="w-1/2 text-sm font-medium text-gray-700">
                        @if (chipDetails.animal.coatType === '1') {
                            {{ "chipRegistration.animal.longtHair" | translate }}
                        }
                        @if (chipDetails.animal.coatType === '2') {
                            {{ "chipRegistration.animal.shortHair" | translate }}
                        }
                        @if (chipDetails.animal.coatType === '3') {
                            {{ "chipRegistration.animal.noHair" | translate }}
                        }
                    </span>
                </li>
                <li class="flex items-center gap-5 py-2.5">
                    <span class="w-1/2 text-sm text-gray-500">{{ "chipRegistration.animal.size" | translate }}</span>
                    <span class="w-1/2 text-sm font-medium text-gray-700">
                        {{ getAnimalSize() }}
                    </span>
                </li>
                <li class="flex items-center gap-5 py-2.5">
                    <span class="w-1/2 text-sm text-gray-500">{{ "chipRegistration.animal.castrated" | translate }}</span>
                    <span class="w-1/2 text-sm font-medium text-gray-700">
                        @if (chipDetails.animal.castrated) {
                            <svg class="size-6" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path d="m4.5 12.75 6 6 9-13.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        } @else {
                            <svg class="size-6" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6 18 18 6M6 6l12 12" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        }
                    </span>
                </li>
            </ul>
        </div>
    </div>
    <app-address-render-info [address]="chipDetails.animal.addresses" [ownerAddress]="false" />
}
